import { combineReducers } from 'redux';
import get from 'lodash.get';
import { selectPlanId, selectRunnerId } from './auth';
import { getWorkoutDay } from './workouts';
import prepareBody from '../utils/prepareBody';

export const FETCH_ANALYTICS = 'FETCH_ANALYTICS';
export const FETCH_ANALYTICS_SUCCESS = 'FETCH_ANALYTICS_SUCCESS';
export const FETCH_ANALYTICS_FAILURE = 'FETCH_ANALYTICS_FAILURE';
export const FETCH_YOUR_DATA = 'FETCH_YOUR_DATA';
export const FETCH_YOUR_DATA_SUCCESS = 'FETCH_YOUR_DATA_SUCCESS';
export const FETCH_YOUR_DATA_FAILURE = 'FETCH_YOUR_DATA_FAILURE';

export function dataReducer(state = {}, action) {
    switch (action.type) {
        case FETCH_ANALYTICS:
            return {};
        case FETCH_ANALYTICS_SUCCESS:
            return mapResults(action.result);
        default:
            return state;
    }
}

export function yourDataReducer(state = {
    loading: false,
    error: false,
    markdown: '',
}, action) {
    switch (action.type) {
        case FETCH_YOUR_DATA:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case FETCH_YOUR_DATA_SUCCESS:
            return {
                loading: false,
                error: false,
                markdown: get(action, 'result["Markdown Output"]', ''),
                planIds: get(action, 'result["Plan ID"]', ''),
            };
        case FETCH_YOUR_DATA_FAILURE:
            return {
                error: true,
                loading: false,
                markdown: '',
            };
        default:
            return state;
    }
}

export function loadingReducer(state = false, action) {
    switch (action.type) {
        case FETCH_ANALYTICS:
            return true;
        case FETCH_ANALYTICS_SUCCESS:
        case FETCH_ANALYTICS_FAILURE:
            return false;
        default:
            return state;
    }
}

export function errorReducer(state = null, action) {
    switch (action.type) {
        case FETCH_ANALYTICS:
        case FETCH_ANALYTICS_SUCCESS:
            return null;
        case FETCH_ANALYTICS_FAILURE:
            return action.error;
        default:
            return state;
    }
}

export default combineReducers({
    data: dataReducer,
    yourData: yourDataReducer,
    loading: loadingReducer,
    error: errorReducer,
});

export const fetchAnalyticsAction = day => ({
    types: [FETCH_ANALYTICS, FETCH_ANALYTICS_SUCCESS, FETCH_ANALYTICS_FAILURE],
    promise: ({ getState }) => {
        const state = getState();
        const planId = selectPlanId(state);
        const runnerId = selectRunnerId(state);
        const race = state.race.info;
        const totalWorkouts = race.plan_week * 7;
        const raceDate = race.race_date;
        return fetch(`${process.env.RTAPI_URL}/API_data_runnermatch.php`, {
            method: 'POST',
            body: prepareBody({
                plan_id: planId,
                runner_id: runnerId,
                training_day: getWorkoutDay({ day, totalWorkouts, raceDate }),
            }),
        }).then(res => res.json());
    },
});

export const fetchAnalyticsData = () => ({
    types: [FETCH_YOUR_DATA, FETCH_YOUR_DATA_SUCCESS, FETCH_YOUR_DATA_FAILURE],
    promise: ({ getState }) => (
        fetch(`${process.env.RTAPI_URL}/API_data_runner.php`, {
            method: 'POST',
            body: prepareBody({
                plan_id: selectPlanId(getState()),
                runner_id: selectRunnerId(getState()),
            }),
        }).then(res => res.json())
    ),
});

export const mapResults = results => ({
    weekVolume: {
        average: get(results, 'Match Data.WeekVolume', 0) || 0,
        offset: get(results, 'Match Data.WeekVolumeSD', 0) || 0,
        value: get(results, 'Runner.WeekVolume', 0) || 0,
        description: get(results, 'Match Data.WeekVolumeDescription', '') || '',
    },
    longRunPace: {
        average: get(results, 'Match Data.Longrun_pace', '') || '',
        offset: get(results, 'Match Data.Longrun_paceSD', '') || '',
        value: get(results, 'Runner.Longrun_pace', '') || '',
        description: get(results, 'Match Data.Longrun_paceDescription', '') || '',
    },
    regularRunPace: {
        average: get(results, 'Match Data.Regrun_pace', '') || '',
        offset: get(results, 'Match Data.Regrun_paceSD', '') || '',
        value: get(results, 'Runner.Regrun_pace', '') || '',
        description: get(results, 'Match Data.Regrun_paceDescription', '') || '',
    },
    peakLongRun: {
        average: get(results, 'Match Data.Peaklongrun', '') || '',
        offset: get(results, 'Match Data.PeaklongrunSD', '') || '',
        value: get(results, 'Runner.Peaklongrun', '') || '',
        description: get(results, 'Match Data.PeaklonrunDescription', '') || '',
    },
    peakLongRunPace: {
        average: get(results, 'Match Data.Peaklongrun_pace', '') || '',
        offset: get(results, 'Match Data.Peaklongrun_paceSD', '') || '',
        value: get(results, 'Runner.Peaklongrun_pace', '') || '',
        description: get(results, 'Match Data.Peaklongrun_PaceDescription', '') || '',
    },
    based: {
        totalRunners: get(results, 'Match Data.NumberMatch', 0) || 0,
        completedDescription: get(results, 'Match Data.CompletedWorkoutDescription', '') || '',
        lowAge: get(results, 'Match Data.Low Age', 0) || 0,
        highAge: get(results, 'Match Data.High Age', 100) || 0,
        femaleAge: get(results, 'Match Data.Female', '') || 0,
        maleAge: get(results, 'Match Data.Male', '') || 0,
    },
    topMatch: {
        weekVolume: get(results, 'Top Match.Ave_WeekVolume', ''),
        age: get(results, 'Top Match.Age', '') || '',
        finishTime: get(results, 'Top Match.Finish_Time', '') || '',
        experiance: get(results, 'Top Match.Experience', '') || '',
        regularRunPace: get(results, 'Top Match.RR_pace', '') || '',
        longRunPace: get(results, 'Top Match.LR_pace', '') || '',
        peakLongRunDistance: get(results, 'Top Match.Peak_Longrun', '') || '',
        peakLongRunPace: get(results, 'Top Match.Peak_Longrunpace', '') || '',
        totalRunners: get(results, 'Match Data.NumberMatch', 0),
    },
});



/** WEBPACK FOOTER **
 ** ./src/redux/analytics.js
 **/